import React from 'react';

import { CasinoDesktopHeader } from '@/feature/lobby-casino/components/CasinoDesktopHeader';
import { useIsDesktopWeb } from '@/feature/responsive-design/hooks/use-is-desktop-web';

import { TabBar, TabOptions } from '../tabs';
import { CasinoTabsNavigatorProps } from './types';

const MOBILE_NAVIGATOR_PROPS: CasinoTabsNavigatorProps = { screenOptions: TabOptions, tabBar: TabBar };

/**
 * At desktop widths the top navigation replaces the bottom tab bar, so it stays mounted while
 * navigating between the tabs it links to.
 */
const DESKTOP_NAVIGATOR_PROPS: CasinoTabsNavigatorProps = {
    screenOptions: { ...TabOptions, tabBarPosition: 'top' },
    tabBar: () => <CasinoDesktopHeader />,
};

/**
 * Web casino tab navigator props: the desktop top navigation at `lg`, the mobile bottom tab bar below it.
 */
export const useCasinoTabsNavigator = (): CasinoTabsNavigatorProps => {
    const isDesktopWeb = useIsDesktopWeb();

    return isDesktopWeb ? DESKTOP_NAVIGATOR_PROPS : MOBILE_NAVIGATOR_PROPS;
};
